import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Constants } from '@sharedConstants/constants';
import { Moment } from 'moment';
import { UserService } from './user.service';
import { AppContextService } from './app-context.service';

@Injectable({ providedIn: 'root' })
export class DateTimeService {
  private defaultLocale = 'fr-FR';

  private inputDateFormat = Constants.MOMENT_DATE_FORMAT;
  private inputDateTimeFormat = Constants.MOMENT_DATE_TIME_FORMAT;

  private outputDateFormat = Constants.DATE_FORMAT;
  private outputDateTimeFormat = Constants.DATE_TIME_FORMAT;
  private outputDateTimeFormatWithoutMs = Constants.DATE_TIME_FORMAT_WITHOUS_MS;

  private inputDatePattern = Constants.MOMENT_DATE_FORMAT_REGEX;

  constructor(
    appContextService: AppContextService,
    userService: UserService) {
    // Just to display the Material Labels (Months, Days...) in English => WE DONT CHANGE THE INPUT/OUTPUT FORMAT
    if (appContextService?.lang?.toUpperCase() == 'EN') {
      this.defaultLocale = 'en-US';
    }

    // If the user is US => Change the Labels/Format of the dates
    if (userService?.currentUser?.userCountry?.isUserUS == true) {
      this.defaultLocale = 'en-US';

      this.inputDateFormat = Constants.MOMENT_DATE_FORMAT_US;
      this.inputDateTimeFormat = Constants.MOMENT_DATE_TIME_FORMAT_US;

      this.outputDateFormat = Constants.DATE_FORMAT_US;
      this.outputDateTimeFormat = Constants.DATE_TIME_FORMAT_US;
      this.outputDateTimeFormatWithoutMs =
        Constants.DATE_TIME_FORMAT_WITHOUS_MS_US;

      this.inputDatePattern = Constants.MOMENT_DATE_US_FORMAT_REGEX;
    }
  }

  getInputDatePattern = (): RegExp => {
    return this.inputDatePattern;
  }

  getInputDateFormat = (): string => {
    return this.inputDateFormat;
  };

  getOutputDateFormat = () => {
    return this.outputDateFormat;
  };

  getInputDateTimeFormat = (): string => {
    return this.inputDateTimeFormat;
  };

  getOutputDateTimeFormat = (withMs: boolean = true) => {
    return withMs
      ? this.outputDateTimeFormat
      : this.outputDateTimeFormatWithoutMs;
  };

  getLocale = (): string => {
    return this.defaultLocale;
  };

  getDateTimeNowAsString = (): string => {
    var now = new Date();
    var dateTimeAsString = `${now.getFullYear()}${now.getMonth() + 1}${now.getDate()}${now.getHours()}${now.getMinutes()}${now.getSeconds()}`;

    return dateTimeAsString;
  }
}

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {
  constructor(private dateTimeService: DateTimeService) {
    super(dateTimeService.getLocale());
  }

  public parse(value: any): Moment | null {
    const format = this.dateTimeService.getInputDateFormat();

    return super.parse(value, format);
  }

  public format(date: moment.Moment): string {
    const locale = this.dateTimeService.getLocale();
    const format = this.dateTimeService.getInputDateFormat();

    return date.locale(locale).format(format);
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }
}
